<template>
<mdb-modal :show="modalScan" title="Scan Qr" size="lg" @close="modalScan = false" modal>
            <mdb-modal-header>
                <mdb-modal-title class="font-weight-bold">Scan Qr</mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body>

            {{ decodedString }}
                    <camera-scanner @decode="onDecode" ref="cameraScanner" :track="repaint" class="m-1" :constraints="constraints" :showReset="true" :showChange="true" :showStart="true"></camera-scanner>

                    <template v-if="checking">
                        <p class="text-center"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Searching product...</p> 
                    </template>
                    <template v-if="notfound && checking == false">
                        <p class="text-center">No product found.</p> 
                    </template>

          </mdb-modal-body>
      </mdb-modal>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {mdbRow, mdbCol, mdbCard, mdbCardBody,  mdbBtn, mdbModal, mdbModalBody, mdbModalHeader, mdbModalTitle} from 'mdbvue'
import CameraScanner from '../CameraScanner'
export default {
    name : "ScanModal",
    components : {
        CameraScanner,
        mdbRow, mdbCol, mdbCard, mdbCardBody, mdbBtn, mdbModal, mdbModalBody, mdbModalHeader, mdbModalTitle
    },
    data : () => ({
        modalScan : false,
        checking : false,
        notfound : false,
        decodedString : null,
        constraints: {
            facingMode: 'user'
        },

        scannerKey : 0
    }),
    
    methods : {
        ...mapActions('ProductModule', [
            'getProduct'
        ]),
        onDecode(decodedString){
            this.decodedString = decodedString;
            this.checking = true;
            
            // this.viewProduct(decodedString)
            this.modalScan = false
            this.$router.push({ name: 'product', query: { item: decodedString } });
        },

        repaint (location, ctx) {
            const {
            topLeftCorner,
            topRightCorner,
            bottomLeftCorner,
            bottomRightCorner,
            } = location

            ctx.strokeStyle = 'blue' // instead of red

            ctx.beginPath()
            ctx.moveTo(topLeftCorner.x, topLeftCorner.y)
            ctx.lineTo(bottomLeftCorner.x, bottomLeftCorner.y)
            ctx.lineTo(bottomRightCorner.x, bottomRightCorner.y)
            ctx.lineTo(topRightCorner.x, topRightCorner.y)
            ctx.lineTo(topLeftCorner.x, topLeftCorner.y)
            ctx.closePath()

            ctx.stroke()
        },

        viewProduct(series){
            const self = this
            this.modalKey++
            this.modalLoading = true
            self.productLoading = true
            this.getProduct(series).then((response) => {
                self.product = {
                    ...response,
                    U_imgURL : response.U_imgURL.replace(/\/(small|thumb)-/, "/large-")
                }
                self.productLoading = false
                self.modalScan = false
                self.modal = true
                self.modalLoading = false
                // self.getDefault()
            }).catch((err) => {

                console.log("View Product error",err)
                 self.modal = false
                self.productLoading = false
                self.checking = false
                self.notfound = true
                self.modalLoading = false
            })
        },

        openModal(){
            this.scannerKey ++
            this.modalScan = true
        },

        closeModal(){
            this.modalScan = false
            this.decodedString = null
            this.scannerKey ++
            this.checking = false
        }

    },

    computed : {
        ...mapGetters('CartModule',['cart']),
        cartTotal : function(){
            const total = this.cart.map((item) => {
                    return this.$utils.unformat(item.LineTotal)
                }).reduce((a, b) => a + b, 0);
            return this.$utils.formatMoney(total);
        }
    },

}
</script>